import { render } from "./AcknowledgeDenyWarnings.vue?vue&type=template&id=6ff0462d&scoped=true"
import script from "./AcknowledgeDenyWarnings.vue?vue&type=script&lang=js"
export * from "./AcknowledgeDenyWarnings.vue?vue&type=script&lang=js"

import "./AcknowledgeDenyWarnings.vue?vue&type=style&index=0&id=6ff0462d&lang=scss&scoped=true"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff0462d"]])

export default __exports__